import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import actions from '../../../../store/actions';
import { profileSelectors } from '../../../../store/selectors/profile';
import { authSelectors } from '../../../../store/selectors/auth';
import { editUserInfoThunk } from '../../../../store/thunks/profile';

import Field from '../../../../common/Fields/Field';
import LoadingBtn from '../../../LoadingBtn/LoadingBtn';
import ErrorMessage from '../../../../common/Errors/ErrorMessage';

const BirthdayForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector(profileSelectors);
  const auth = useSelector(authSelectors);
  const token = auth.token;
  const user = profile.user;
  const errors = profile.errors;
  const load = profile.load;
  const edit = profile.edit;
  const confirmInfo = profile.confirmInfo;

  const [birthday, setBirthday] = useState('');
  const [fieldConfirmed, setFieldConfirmed] = useState('');

  useEffect(() => {
    if (edit) {
      navigate('/profile');
      dispatch(actions.profile.editUserInfo(false));
      dispatch(actions.profile.profileError({}));
    }
  }, [edit]);

  useEffect(() => {
    if (Object.keys(user).length > 0 && user.birth_date) {
      setBirthday(user.birth_date);
    }
  }, [user]);

  useEffect(() => {
    if (confirmInfo.length > 0) {
      setFieldConfirmed(confirmInfo.find(field => field.field === 'birth_date'));
    }
  }, [confirmInfo]);

  useEffect(() => {
    if (fieldConfirmed) {
      setBirthday(fieldConfirmed.value_to);
    }
  }, [fieldConfirmed]);

  const handleEdit = (e) => {
    e.preventDefault();
    dispatch(editUserInfoThunk({ value: birthday, field: 'birth_date', token }));
  };

  return (
    <form className='form profile-form'>
      <Field
        name="birth_date"
        type="date"
        value={birthday}
        labelText="Дата народження"
        onChange={(e) => setBirthday(e.target.value.trim())}
        formClass="required"
        required
      />
      {errors?.value && errors.value.map(err => <ErrorMessage key={err} errorText={err} />)}

      <div className="profile__btns">
        <LoadingBtn load={load} btnText='Змінити' onClick={handleEdit} />
      </div>
    </form>
  );
};

export default BirthdayForm;